module.exports = __webpack_public_path__ + "img/about_logo_04.327bbd77.png";